var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"24px"}},_vm._l((_vm.blockMap),function(item){return _c('notion',{key:item.value.id,attrs:{"item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }